import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Spinner } from './Spinner';

function SummaryCardComparison({
    className,
    hideBackground,
    border,
    icon,
    title,
    value1,
    value1TextColor,
    value2,
    value2TextColor,
    comparisonIcon,
    comparisonIconColor,
    comparisonValue,
    comparisonValueColor,
    comparisonGrowth,
    comparisonGrowthColor,
    loading }) {
  return (
    <div className={`${hideBackground ? '' : 'bg-white shadow-md'} ${border ? 'border' : ''} px-4 py-2 h-full hover:scale-120 ${className}`}>
      <div className="text-left">
        <div className="flex">
          {icon && (
            <FontAwesomeIcon
              icon={icon}
              className="my-auto text-2xl mr-2"
            />
          )}
          <p className="text-xl">{title}</p>
        </div>
        <div className="flex flex-col leading-0">
          {!loading && (
            <p className="mt-2 leading-none text-right text-lg">
              <span className={`font-bold ${value1TextColor ?? 'text-accentTextColor'}`}>{value1}</span>
              {value1 && value2 && <span className="mx-2">:</span>}
              <span className={value2TextColor ?? 'text-accentTextColor'}>{value2}</span>
            </p>
          )}
          {!loading && (
            <p className="text-right mt-2 text-md">
              {comparisonIcon && (
                <FontAwesomeIcon
                  icon={comparisonIcon}
                  className={`${comparisonIconColor ?? 'text-accentTextColor'} text-xl mr-2`}
                />
              )}
              {comparisonValue && (
                <span className={`${comparisonValueColor ?? 'text-accentTextColor'}`}>{comparisonValue}</span>
              )}
              {comparisonValue && comparisonGrowth && <span className="mx-2">:</span>}
              {comparisonGrowth && (
                <span className={`${comparisonGrowthColor ?? 'text-accentTextColor'}`}>{comparisonGrowth}</span>
              )}
            </p>
          )}
        </div>
        {loading && (
          <div className="float-right flex items-center">
            <Spinner className="float-right text-accentColor" />
          </div>
        )}
      </div>
    </div>
  );
}

export default SummaryCardComparison;
